/**
 * Calendar wrapper to configure a bootstrap-datetimepicker widget. This
 * expects that the element the calendar is rendered into has a data-deadline
 * set so that we know to highlight the date properly (even if that value is
 * null).
 *
 * In the future, this will provide an API for highlighting additional days,
 * for events and such.
 */

import 'eonasdan-bootstrap-datetimepicker'

export default class Calendar {
  constructor(selector) {
    this.selector = selector;
    this.$el = $(selector);
    this.deadlines = this.$el.data('deadlines');
    this.publishMonth = this.$el.data('publishMonth')

    let cb = this.highlightCalendarDays.bind(this);
    let monthChange = this.changeIssueMonth.bind(this);

    this.$el.datetimepicker({
      inline: true,
      format: "dddd, MMMM Do YYYY",
      defaultDate: this.publishMonth,
    }).
    on({
      'dp.change': cb,
      'dp.update': monthChange,
      'dp.show': cb
    });

    this.highlightCalendarDays();
  }

  highlightCalendarDays() {
    this.highlightDeadlineDay();
    // this.highlightEventDays() etc
  }

  changeIssueMonth(e) {
    N2.mergeParams({issue: e.viewDate.format().split('T')[0]})
  }

  highlightDeadlineDay() {
    var matchData, el;
    $.each($('[data-action=selectDay]'), (idx, item) => {
      let el = $(item);
      if (this.deadlines.includes(el.data('day'))) {
        el.addClass('deadline');
      }
    });
  }

  hideNextPrev() {
    let $picker = this.$el.find("th.picker-switch")
    let $nextPrev = this.$el.find("th.next, th.prev")
    requestAnimationFrame(() => {
      $nextPrev.remove()
      $picker.attr("colspan", 9)
    })
  }

  unload() {
    $("#main-calendar").html("")
  }

  static init(sel) {
    return new Calendar(sel)
  }
}
